import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.css";
import Logo from "../../Assets/logo_new.png";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Check if user is logged in - runs on mount and when storage changes
  useEffect(() => {
    const checkLoggedInUser = () => {
      // Check both storage locations
      const userFromLocal = localStorage.getItem("userName");
      const userFromSession = sessionStorage.getItem("userName");

      if (userFromLocal || userFromSession) {
        setLoggedInUser(userFromLocal || userFromSession);
      } else {
        setLoggedInUser(null);
      }
    };

    // Initial check
    checkLoggedInUser();

    // Listen for storage changes
    const handleStorageChange = () => {
      checkLoggedInUser();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleNavClick = () => {
    setExpanded(false);
    setDropdownOpen(null);
  };

  const handleMouseEnter = (dropdown) => {
    setDropdownOpen(dropdown);
  };

  const handleMouseLeave = () => {
    setDropdownOpen(null);
  };

  const handleLogout = () => {
    // Clear user data from storage
    localStorage.removeItem("userName");
    localStorage.removeItem("emailId");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("emailId");
    sessionStorage.removeItem("userId");
    setLoggedInUser(null);
  };

  return (
    <Navbar
      bg={scrolled ? "white" : "transparent"}
      variant={scrolled ? "light" : "dark"}
      expand="lg"
      className={`py-3 modern-navbar ${scrolled ? "scrolled" : ""}`}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      fixed="top"
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src={Logo}
            alt="AMPICON 2025 Logo"
            className="d-inline-block align-top border-0"
            style={{ height: "65px" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="border-0 shadow-none"
          style={{ color: "#000", outline: "none", boxShadow: "none" }}
        >
          {expanded ? "✖" : "☰"}
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto hover-nav d-flex align-items-center">
            {/* New Nav Item without dropdown */}
            <Nav.Link
              as={Link}
              to="/"
              className={`fw-bold nav-item ${
                scrolled ? "text-dark" : "text-white"
              }`}
              onClick={handleNavClick}
            >
              Home
            </Nav.Link>
            {/* AMPICON 2025 */}
            <NavDropdown
              title="TNPY AMPICON 2025"
              id="ampicon-dropdown"
              className={`fw-bold nav-item ${
                scrolled ? "text-dark" : "text-white"
              }`}
              show={dropdownOpen === "ampicon"}
              onMouseEnter={() => handleMouseEnter("ampicon")}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item
                as={Link}
                to="/organizing-committee"
                onClick={handleNavClick}
              >
                Organizing Committee
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/science-committee"
                onClick={handleNavClick}
              >
                Scientific Committee
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/science-committee-members"
                onClick={handleNavClick}
              >
                Scientific Committee Members
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/regional-advisory-committe"
                onClick={handleNavClick}
              >
                Regional Advisory Committee
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/TNPY-advisory-committee"
                onClick={handleNavClick}
              >
                TNPY Advisory Committee
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/AMPI-TNPY-executive-committee"
                onClick={handleNavClick}
              >
                AMPI TNPY Executive Committee
              </NavDropdown.Item>
            </NavDropdown>

            {/* Program */}
            <NavDropdown
              title="Program"
              id="program-dropdown"
              className={`fw-bold nav-item ${
                scrolled ? "text-dark" : "text-white"
              }`}
              show={dropdownOpen === "program"}
              onMouseEnter={() => handleMouseEnter("program")}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item
                as={Link}
                to="/preconference-workshop"
                onClick={handleNavClick}
              >
                Pre-Conference Workshop
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/conference-highlights"
                onClick={handleNavClick}
              >
                Photo Gallery
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/invited-speakers"
                onClick={handleNavClick}
              >
                Invited Speakers
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/scientific-program"
                onClick={handleNavClick}
              >
                Scientific Program
              </NavDropdown.Item>
            </NavDropdown>

            {/* Abstraction */}
            <NavDropdown
              title="Abstract"
              id="abstraction-dropdown"
              className={`fw-bold nav-item ${
                scrolled ? "text-dark" : "text-white"
              }`}
              show={dropdownOpen === "abstraction"}
              onMouseEnter={() => handleMouseEnter("abstraction")}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item
                as={Link}
                to="/abstract"
                onClick={handleNavClick}
              >
                Abstract Guidelines
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/abstract-submission"
                onClick={handleNavClick}
              >
                Abstract Submission
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/awards-and-honors"
                onClick={handleNavClick}
              >
                Awards and Honors
              </NavDropdown.Item>
            </NavDropdown>

            {/* Information */}
            <NavDropdown
              title="Information"
              id="information-dropdown"
              className={`fw-bold nav-item ${
                scrolled ? "text-dark" : "text-white"
              }`}
              show={dropdownOpen === "information"}
              onMouseEnter={() => handleMouseEnter("information")}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item as={Link} to="/venue" onClick={handleNavClick}>
                Venue
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/sponsors"
                onClick={handleNavClick}
              >
                Sponsors
              </NavDropdown.Item>
              <NavDropdown.Item
                as="a"
                href="https://www.apollohospitals.com/cancer-treatment-centres/cancers/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleNavClick}
              >
                About ACC
              </NavDropdown.Item>
              {/* <NavDropdown.Item
                as={Link}
                to="/accommodation"
                onClick={handleNavClick}
              >
                Accommodation
              </NavDropdown.Item> */}
              <NavDropdown.Item
                as={Link}
                to="/chennai-tourism"
                onClick={handleNavClick}
              >
                Chennai, Tourism
              </NavDropdown.Item>
            </NavDropdown>

            {/* Login/Register or User Profile */}
            {loggedInUser ? (
              <NavDropdown
                title={
                  <span
                    className="text-white"
                    // className={scrolled ? "text-dark" : "text-white"}
                  >
                    Hi, {loggedInUser}
                  </span>
                }
                id="user-dropdown"
                className="fw-bold nav-item regLogin"
                show={dropdownOpen === "user"}
                onMouseEnter={() => handleMouseEnter("user")}
                onMouseLeave={handleMouseLeave}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/userProfile"
                  onClick={handleNavClick}
                >
                  <i className="fas fa-user me-2"></i>
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => {
                    handleLogout();
                    handleNavClick();
                    navigate("/login-page");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <div className="ms-3 fw-bold regLogin">
                <Link
                  to="/registration"
                  className="text-white"
                  // className={scrolled ? "text-dark" : "text-white"}
                  style={{ textDecoration: "none" }}
                >
                  Register
                </Link>
                <span
                  className="text-white"
                  // className={`mx-2 ${scrolled ? "text-dark" : "text-white"}`}
                >
                  /
                </span>
                <Link
                  to="/login-page"
                  className="text-white"
                  // className={scrolled ? "text-dark" : "text-white"}
                  style={{ textDecoration: "none" }}
                >
                  Login
                </Link>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
